import { useState, useEffect } from 'react';

// Detect mobile screen size, so we can render some bits like the add new task button in the footer.
// This UI behaviour is experimental for now.
export const useMobile = (breakpoint = 768): { isMobile: boolean; portalContainer: Element } => {
    const [isMobile, setIsMobile] = useState(false);
    const portalContainer = document.querySelector('footer.automate-footer .content-wrapper')!;

    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            document.body.offsetWidth <= breakpoint ? setIsMobile(true) : setIsMobile(false);
        });

        resizeObserver.observe(document.body);

        return () => {
            resizeObserver.unobserve(document.body);
        };
    }, [breakpoint]);

    return {
        isMobile,
        portalContainer,
    };
};
